// extracted by mini-css-extract-plugin
export default {"_dm-icon--locked":"LockedIndicator__dm-icon--locked__KR5-8","_dm-icon--locked-container":"LockedIndicator__dm-icon--locked-container__gn6bK","aria":"LockedIndicator_aria__G0+eU"};